import { Link } from "react-router-dom";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { Seo } from "../../components/common/Seo";

function Error404() {
    return (
        <Layouts>
            <Seo
                title="Página no encontrada | EMMPIEZA"
                description="La página solicitada no existe en EMMPIEZA."
                path={window.location.pathname}
                robots="noindex,follow"
            />
            <header className="shrink-0">
                <NavbarComponent />
            </header>

            <main className="flex min-h-[calc(100vh-1px)] flex-col items-center justify-center bg-em-bg px-5 pb-[calc(5rem+var(--em-footer-h))] pt-32 text-center text-em-text sm:pt-36 md:pt-40 font-[Inter,system-ui,sans-serif]">
                <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-em-accent2">
                    Error
                </p>
                <p
                    className="select-none bg-gradient-to-br from-em-accent via-em-vivid2 to-em-accent2 bg-clip-text text-8xl font-black leading-none text-transparent sm:text-9xl"
                    aria-hidden
                >
                    404
                </p>
                <h1 className="mt-6 max-w-lg text-2xl font-bold tracking-tight text-em-text sm:text-3xl">
                    Página no encontrada
                </h1>
                <p className="mt-4 max-w-md text-base text-em-soft">
                    La ruta que buscas no existe o fue movida. Revisa la URL o vuelve al inicio.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-em-vivid to-em-vivid2 px-8 py-3.5 text-sm font-semibold text-em-ink shadow-lg shadow-em-vivid/25 transition hover:opacity-95"
                    >
                        Ir al inicio
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="h-4 w-4"
                            aria-hidden
                        >
                            <path
                                fillRule="evenodd"
                                d="M9.293 2.293a1 1 0 011.414 0l7 7a1 1 0 010 1.414l-7 7a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-5.293-5.293a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </Link>
                    <Link
                        to="/contacto"
                        className="inline-flex rounded-full border border-em-text/15 px-8 py-3.5 text-sm font-semibold text-em-text transition hover:border-em-accent/40 hover:bg-em-text/5"
                    >
                        Contacto
                    </Link>
                </div>
            </main>

            <Footer />
        </Layouts>
    );
}

export default Error404;
